import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { FaArrowUp, FaCalendarAlt } from "react-icons/fa";

const sampleData = [
  { name: "Jan", visitors: 4000 },
  { name: "Feb", visitors: 3000 },
  { name: "Mar", visitors: 5000 },
  { name: "Apr", visitors: 4000 },
  { name: "May", visitors: 6000 },
  { name: "Jun", visitors: 7000 },
  { name: "Jul", visitors: 8000 },
  { name: "Aug", visitors: 9000 },
  { name: "Sep", visitors: 10000 },
  { name: "Oct", visitors: 11000 },
  { name: "Nov", visitors: 12000 },
  { name: "Dec", visitors: 13000 },
];

const summary = [
  { label: "Total visitors", value: "120,000", helper: "+18% growth", icon: FaArrowUp },
  { label: "Daily average", value: "4,000", helper: "Stable traffic", icon: FaCalendarAlt },
  { label: "Peak month", value: "December", helper: "13k visitors", icon: FaArrowUp },
];

const VisitorsAnalytics = () => {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="text-lg font-bold text-slate-950">Visitors Analytics</h3>
          <p className="text-sm text-slate-500">Monthly audience trend across the platform</p>
        </div>
        <div className="rounded-lg bg-sky-50 p-3 text-sky-600 ring-1 ring-sky-100">
          <FaCalendarAlt />
        </div>
      </div>

      <div className="h-72">
        <ResponsiveContainer>
          <LineChart data={sampleData} margin={{ top: 10, right: 8, left: -18, bottom: 0 }}>
            <CartesianGrid stroke="#e2e8f0" strokeDasharray="4 4" vertical={false} />
            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: "#64748b", fontSize: 12 }} />
            <YAxis axisLine={false} tickLine={false} tick={{ fill: "#64748b", fontSize: 12 }} />
            <Tooltip
              contentStyle={{
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
              }}
            />
            <Line
              type="monotone"
              dataKey="visitors"
              stroke="#0284c7"
              strokeWidth={3}
              dot={{ stroke: "#0284c7", strokeWidth: 2, r: 3, fill: "#ffffff" }}
              activeDot={{ r: 6, stroke: "#0284c7", strokeWidth: 2, fill: "#ffffff" }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-3">
        {summary.map((item) => {
          const Icon = item.icon;

          return (
            <div key={item.label} className="rounded-lg border border-slate-100 bg-slate-50 p-4">
              <div className="mb-3 flex items-center justify-between gap-3">
                <p className="text-sm font-medium text-slate-500">{item.label}</p>
                <Icon className="text-emerald-600" />
              </div>
              <p className="text-xl font-bold text-slate-950">{item.value}</p>
              <p className="mt-1 text-xs font-medium text-slate-500">{item.helper}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VisitorsAnalytics;
